import React from "react"

import { LazyImage } from "components"
import { thousandSeparator } from "utils"

import classes from "./ComboModalHeader.module.scss"

const ComboModalHeader = props => {
  const { combo, selectedComboItems } = props

  const totalAddAmounts =
    selectedComboItems.reduce((to, comboItem) =>
      to +=
      !!comboItem ?
        comboItem.quantity * comboItem.addAmount : 0
      , 0
    )

  return (
    <div className={classes["header"]}>
      <LazyImage
        src={combo.image}
        imageWidth={100}
        quality={80}
        className={classes["image"]}
      />
      <div className={classes["details"]}>
        <div className={classes["name"]}>
          {combo.name}
        </div>
        <div className={classes["price"]}>
          {thousandSeparator(
            combo.comboSetSalePrice + totalAddAmounts
          )}
        </div>
      </div>
    </div>
  )
}

export default ComboModalHeader